import { CampaignFiltersEnum } from "features/Library/SimulatedPhishing/Campaigns/types/models";
import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "enums/filterViewTypes";

export const getCampaignsFilters = (includePublishers = true): FilterItemBase<CampaignFiltersEnum>[] => {
  const filters: FilterItemBase<CampaignFiltersEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: CampaignFiltersEnum.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: CampaignFiltersEnum.DateModified,
    },
  ];

  if (includePublishers) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: CampaignFiltersEnum.Publishers,
      placeholder: "All Publishers",
    });
  }

  return [
    ...filters,
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: CampaignFiltersEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: CampaignFiltersEnum.Labels,
      placeholder: "All Labels",
    },
  ];
};
